<ng-container *ngIf="!accepted">
  <div class="policies shadow p-4" @fadeInOut>
    <div class="custom-center p-2" style="justify-content: start">
      <h3 class="m-0 mr-2">Guess what? Cookies!</h3>
      <img src="images/cookies.png" alt="Políticas de Cookies" width="35" />
    </div>

    <div class="p-2">
      <p>
        Este sitio web utiliza cookies necesarias para gestionar su sesión. Al
        continuar navegando, acepta nuestro uso de cookies. Para más
        información, consulte nuestra
        <a href="/cookies" style="color: #ffd700; text-decoration: underline">
          Política de Cookies
        </a>
        .
      </p>
    </div>
    <div class="custom-center" style="justify-content: end">
      <button class="cookie-btn shadow" (click)="acceptCookies()">
        Aceptar
      </button>
      <button class="cookie-btn cancel ml-4" (click)="accepted = true">
        Cancelar
      </button>
    </div>
  </div>
</ng-container>
